import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiEndpointEnum } from '@/enums/ApiEndpointEnum';
import useApiFetch from './useApiFetch';
import type { UpdateCartParams } from '@/types/api/params/UpdateCartParams';
import type { Cart } from '@/types';

/**
 * Generic hook for updating the cart via the UpdateCart API endpoint.
 * Accepts a flexible payload (UpdateCartParams) to support various cart updates
 * such as line item quantity changes, notes, paymentCurrency, etc.
 */
export function useUpdateCart() {
  const qc = useQueryClient();
  const { post } = useApiFetch();

  return useMutation({
    mutationFn: async (payload: UpdateCartParams) => {
      return post(ApiEndpointEnum.UpdateCart, JSON.stringify(payload));
    },
    onSuccess: (data: any) => {
      const cart = (data as any)?.cart || data;
      if (cart) {
        qc.setQueryData(['cart'], cart as Cart);
      } else {
        qc.invalidateQueries({ queryKey: ['cart'] });
      }
    },
  });
}
